export default "__VITE_ASSET__GhviXH3X__"